export const addDonation = donation => ({
  type: 'ADD_DONATION',
  donation,
});



// WEBPACK FOOTER //
// ./src/js/actions/donations.js